//Es necesario colocar aqui los cursos nuevos que se vayan agregando para poder compararlos.
const nuevosCursos = ['XLAM', 'VMIC', 'CO26', 'WOMC'];

//Esta funcion nos permite saber si un curso está en el server globalclickmexico o globalclicklatam
export const validateServerCurso = (codigoLeccion) => {
    return new Promise((resolve, reject) => {
        if(nuevosCursos.includes(codigoLeccion.substring(0,4))){
            // console.log('Es del nuevo server')
            resolve(false);
        } else {
            // console.log("Es del server actual")
            resolve(true);
        }
    })
}